import './EditionPage.scss';
import { SimpleNumberCard } from '@design-system/index';
import { PrestationsSocialesLine } from '@icons';
import { MutationTable } from '@components/Table/MutationTable/MutationTable';
import { ColumnDef } from '@tanstack/react-table';
import { useSocialBenefitEditionPageVM } from './useEditionPageVM';
import { SocialBenefit, SocialBenefitListItem } from '@services/member/member/member.types';
import { formatDate } from '@utils/dates';
import { formatMoney } from '@utils/numbers';
import { useGetSocialBenefitsEditionMutation, useGetSocialBenefitsExportMutation } from '@services/member/list/social-benefits/social-benefits.endpoints';

export default function TicketingEditionPage() {
    const {
        handleMetadata,
        columnHelper,
        socialBenefitsItems,
        totalSocialBenefits
    } = useSocialBenefitEditionPageVM();

    const columns = [
        columnHelper.accessor((row) => row.memberCosemNumber, {
            header: 'N° COSEM',
            id: 'member.cosemNumber',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.recipientFullname, {
            header: 'Adhérent',
            id: 'member.personalInformation.lastname',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.code, {
            header: 'Code',
            id: 'code',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.assignedAt, {
            header: 'Date d\'attribution',
            id: 'assignedAt',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatDate(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.amount, {
            header: 'Montant',
            id: 'amount',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatMoney(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.checkNumber, {
            header: 'Numéro de chèque',
            id: 'checkNumber',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.observation, {
            header: 'Commentaire',
            id: 'observation',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.isArchived, {
            id: 'isArchived',
            header: 'Archivé',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue() ? 'Oui' : 'Non'}</>
        })
    ] as ColumnDef<SocialBenefit>[];

    return (
        <div className="members-table-container">
            <div className="members-table-container-header">
                <div className="members-table-container-header-left">
                    <SimpleNumberCard
                        labelForSingle={'Prestation'}
                        labelForMultiple={'Prestations'}
                        value={totalSocialBenefits}
                    />
                </div>
            </div>
            <MutationTable
                key={'edition'}
                columns={columns}
                selectable={false}
                mutationHook={useGetSocialBenefitsEditionMutation}
                defaultSorting={{
                    field: 'createdAt',
                    direction: 'desc'
                }}
                exportable={true}
                exportMutationHook={useGetSocialBenefitsExportMutation}
                headerTitle={'Édition prestations sociales'}
                headerIcon={<PrestationsSocialesLine />}
                headerIconColor="green-water"
                onMetadata={handleMetadata}
                filters={[
                    {
                        id: 'assignedAt',
                        label: 'Date d\'attribution',
                        type: 'date',
                        comparatorTypes: ['isBetween', 'isBefore', 'isAfter', 'equals']
                    },
                    {
                        id: 'code',
                        label: 'Code',
                        type: 'select',
                        options: socialBenefitsItems.map((socialBenefit: SocialBenefitListItem) => ({ label: socialBenefit.label, value: socialBenefit.code }))
                    },
                    {
                        id: 'isArchived',
                        label: 'Archivé',
                        type: 'boolean'
                    }
                ]}
            />
        </div>
    );
}
